/**
 * Workspace tab definitions per agent module (4–6 tabs, top-right toolbar).
 */

import { tabP } from './agentModuleI18n';

function tab(id, icon, builderKey, countKey) {
  return {
    id,
    label: tabP(id),
    icon,
    builderKey,
    countKey,
  };
}

const SESSIONS_TAB = tab('sessions', 'Clock', 'sessions', 'sessionsCount');
const DOCUMENTS_TAB = tab('documents', 'FileText', 'documents', 'documentsCount');
const INBOX_TAB = tab('inbox', 'Inbox', 'inbox', 'inboxCount');

function tabs(...items) {
  return [...items, SESSIONS_TAB];
}

export const AGENT_WORKSPACE_TABS_BY_MODULE = {
  facturation: tabs(
    INBOX_TAB,
    DOCUMENTS_TAB,
    tab('payments', 'Calendar', 'payments', 'paymentsCount'),
  ),
  inventaire: tabs(
    INBOX_TAB,
    tab('movements', 'ArrowRightLeft', 'movements', 'movementsCount'),
    tab('stock', 'Package', 'stock', 'stockCount'),
    DOCUMENTS_TAB,
  ),
  achats: tabs(
    INBOX_TAB,
    tab('commandes', 'ShoppingCart', 'commandes', 'commandesCount'),
    tab('receptions', 'PackageCheck', 'receptions', 'receptionsCount'),
    DOCUMENTS_TAB,
  ),
  ventes: tabs(
    INBOX_TAB,
    tab('pipeline', 'TrendingUp', 'pipeline', 'pipelineCount'),
    tab('livraisons', 'Truck', 'livraisons', 'livraisonsCount'),
    DOCUMENTS_TAB,
  ),
  rh: tabs(
    INBOX_TAB,
    tab('employes', 'Users', 'employes', 'employesCount'),
    tab('conges', 'Calendar', 'conges', 'congesCount'),
    DOCUMENTS_TAB,
  ),
  pointage: tabs(
    INBOX_TAB,
    tab('pointage', 'Clock', 'pointage', 'pointageCount'),
    tab('conges', 'CalendarDays', 'conges', 'congesCount'),
    DOCUMENTS_TAB,
  ),
  salaires: tabs(
    INBOX_TAB,
    tab('paies', 'Banknote', 'paies', 'paiesCount'),
    tab('cnas', 'FileCheck', 'cnas', 'cnasCount'),
    DOCUMENTS_TAB,
  ),
  situation: tabs(
    INBOX_TAB,
    tab('incidents', 'AlertTriangle', 'incidents', 'incidentsCount'),
    tab('crises', 'Siren', 'crises', 'crisesCount'),
    DOCUMENTS_TAB,
  ),
  caisse: tabs(
    INBOX_TAB,
    tab('journal', 'BookOpen', 'journal', 'journalCount'),
    tab('bons', 'Receipt', 'bons', 'bonsCount'),
    DOCUMENTS_TAB,
  ),
  banque: tabs(
    INBOX_TAB,
    tab('comptes', 'Landmark', 'comptes', 'comptesCount'),
    tab('virements', 'ArrowRightLeft', 'virements', 'virementsCount'),
    DOCUMENTS_TAB,
  ),
  comptabilite: tabs(
    INBOX_TAB,
    tab('ecritures', 'FileSpreadsheet', 'ecritures', 'ecrituresCount'),
    tab('balance', 'Scale', 'balance', 'balanceCount'),
    DOCUMENTS_TAB,
  ),
  tresorerie: tabs(
    INBOX_TAB,
    tab('position', 'Wallet', 'position', 'positionCount'),
    tab('placements', 'PiggyBank', 'placements', 'placementsCount'),
    DOCUMENTS_TAB,
  ),
  budget: tabs(
    INBOX_TAB,
    tab('ecarts', 'BarChart3', 'ecarts', 'ecartsCount'),
    tab('engagements', 'Handshake', 'engagements', 'engagementsCount'),
    DOCUMENTS_TAB,
  ),
  projets: tabs(
    INBOX_TAB,
    tab('taches', 'ListTodo', 'taches', 'tachesCount'),
    tab('ressources', 'Users', 'ressources', 'ressourcesCount'),
    DOCUMENTS_TAB,
  ),
  contrats: tabs(
    INBOX_TAB,
    tab('echeances', 'Calendar', 'echeances', 'echeancesCount'),
    tab('renouvellements', 'RefreshCw', 'renouvellements', 'renouvellementsCount'),
    DOCUMENTS_TAB,
  ),
  production: tabs(
    INBOX_TAB,
    tab('ordres', 'Factory', 'ordres', 'ordresCount'),
    tab('qualite', 'ShieldCheck', 'qualite', 'qualiteCount'),
    DOCUMENTS_TAB,
  ),
  maintenance: tabs(
    INBOX_TAB,
    tab('tickets', 'Wrench', 'tickets', 'ticketsCount'),
    tab('planning', 'Calendar', 'planning', 'planningCount'),
    DOCUMENTS_TAB,
  ),
  qualite: tabs(
    INBOX_TAB,
    tab('nc', 'XCircle', 'nc', 'ncCount'),
    tab('audits', 'ClipboardCheck', 'audits', 'auditsCount'),
    DOCUMENTS_TAB,
  ),
  import_export: tabs(
    INBOX_TAB,
    tab('douane', 'Globe', 'douane', 'douaneCount'),
    tab('expeditions', 'Ship', 'expeditions', 'expeditionsCount'),
    DOCUMENTS_TAB,
  ),
  parc_auto: tabs(
    INBOX_TAB,
    tab('vehicules', 'Car', 'vehicules', 'vehiculesCount'),
    tab('carburant', 'Droplet', 'carburant', 'carburantCount'),
    DOCUMENTS_TAB,
  ),
  logistique: tabs(
    INBOX_TAB,
    tab('colis', 'Package', 'colis', 'colisCount'),
    tab('routes', 'Route', 'routes', 'routesCount'),
    DOCUMENTS_TAB,
  ),
  distribution: tabs(
    INBOX_TAB,
    tab('tournees', 'Route', 'tournees', 'tourneesCount'),
    tab('planning', 'Calendar', 'planning', 'planningCount'),
    DOCUMENTS_TAB,
  ),
  livraison: tabs(
    INBOX_TAB,
    tab('encours', 'Truck', 'encours', 'encoursCount'),
    tab('preuves', 'FileCheck', 'preuves', 'preuvesCount'),
    DOCUMENTS_TAB,
  ),
  point_de_vente: tabs(
    INBOX_TAB,
    tab('ventes', 'Store', 'ventes', 'ventesCount'),
    tab('stock', 'Package', 'stock', 'stockCount'),
    DOCUMENTS_TAB,
  ),
  marketing: tabs(
    INBOX_TAB,
    tab('campagnes', 'Megaphone', 'campagnes', 'campagnesCount'),
    tab('roi', 'TrendingUp', 'roi', 'roiCount'),
    DOCUMENTS_TAB,
  ),
  crm: tabs(
    INBOX_TAB,
    tab('leads', 'UserPlus', 'leads', 'leadsCount'),
    tab('pipeline', 'GitBranch', 'pipeline', 'pipelineCount'),
    DOCUMENTS_TAB,
  ),
  service_client: tabs(
    INBOX_TAB,
    tab('tickets', 'Headphones', 'tickets', 'ticketsCount'),
    tab('sla', 'Clock', 'sla', 'slaCount'),
    DOCUMENTS_TAB,
  ),
  taches: tabs(
    INBOX_TAB,
    tab('mistaches', 'ListTodo', 'mistaches', 'mistachesCount'),
    tab('kanban', 'Columns', 'kanban', 'kanbanCount'),
    DOCUMENTS_TAB,
  ),
  approbations: tabs(
    INBOX_TAB,
    tab('workflows', 'Workflow', 'workflows', 'workflowsCount'),
    tab('statuts', 'CheckSquare', 'statuts', 'statutsCount'),
    DOCUMENTS_TAB,
  ),
  planification: tabs(
    INBOX_TAB,
    tab('calendrier', 'Calendar', 'calendrier', 'calendrierCount'),
    tab('charge', 'BarChart3', 'charge', 'chargeCount'),
    DOCUMENTS_TAB,
  ),
};

export function getWorkspaceTabsForModule(moduleId) {
  return AGENT_WORKSPACE_TABS_BY_MODULE[moduleId] || tabs(INBOX_TAB, DOCUMENTS_TAB);
}

export function getWorkspaceTabById(moduleId, tabId) {
  return getWorkspaceTabsForModule(moduleId).find((item) => item.id === tabId);
}
